import type { Feature, FeatureGroup, FeatureModule } from '../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from './group';
import { DEDUPER_MODULE } from './deduper';
import { CALENDAR_BUILDER_MODULE } from './calendar-builder';
import { EMAIL_DESIGNER_MODULE } from './email-designer';
import { TICKET_SCANNERS_MODULE } from './ticket-scanners';
import { CHECKOUTS_MODULE } from './checkouts';
import { DATA_BRIDGE_MODULE } from './data-bridge';
import { DEVELOPMENT_MODULE } from './development';
import { SETTINGS_MODULE } from './settings';

export { CRM_INTEGRATIONS_FEATURE_GROUP } from './group';
export * from './deduper';
export * from './calendar-builder';
export * from './email-designer';
export * from './ticket-scanners';
export * from './checkouts';
export * from './data-bridge';
export * from './development';
export * from './settings';

export const ALL_CRM_INTEGRATIONS_MODULES: FeatureModule[] = [
  DEDUPER_MODULE,
  CALENDAR_BUILDER_MODULE,
  EMAIL_DESIGNER_MODULE,
  TICKET_SCANNERS_MODULE,
  CHECKOUTS_MODULE,
  DATA_BRIDGE_MODULE,
  DEVELOPMENT_MODULE,
  SETTINGS_MODULE,
];

export const ALL_CRM_INTEGRATIONS_FEATURE_GROUPS: FeatureGroup[] = [
  CRM_INTEGRATIONS_FEATURE_GROUP,
  ...ALL_CRM_INTEGRATIONS_MODULES.flatMap((m) => m.groups),
];

export const ALL_CRM_INTEGRATIONS_FEATURES: Feature[] = ALL_CRM_INTEGRATIONS_MODULES.flatMap((m) => m.features);
